import { useQuery } from '@apollo/client/react';

import { GET_PLACEHOLDERS_QUERY } from './query.gql';

const useGetAllPlaceholders = ({ skip = false } = {}) => {
  const { data, loading } = useQuery(GET_PLACEHOLDERS_QUERY, { skip });
  return {
    loading,
    placeholders: data?.allPlaceholder ?? [],
  };
};

export default useGetAllPlaceholders;
